import { useEffect, useState } from "react";
import "./main.css";
import Header from "./header/header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { useCookies } from "react-cookie";
import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import Typewriter from "react-ts-typewriter";
import FlipCard from "./flipCard";
import ChristmasBonanza from "./christmasBonus";
import OneTapLogin from "./OneTapLogin";
import {
  getDiscountPercentage,
  checkIfInDecember,
  PopulateContext,
} from "../App";
import CohortCountdown from "./cohortCountdown";
import PromoDeskView from "./header/promoDeskView";
import PromoMobileView from "./header/promoMobileView";
import { useCourses } from "./Contexts/CoursesContext";

function NewMain() {
  const [authUser, setAuthUser] = useState(false);
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [showDetails, setShowDetails] = useState(false);
  const [isShow, invokeModal] = useState(false);
  const { weAreInDecember } = checkIfInDecember();
  const [promoclose, setPromoclose] = useState(false);
  const [promoModal, setPromomodal] = useState(true);
  const [viewSize, setViewsize] = useState(window.innerWidth);
  const [aquireSkill, setaquireSkill] = useState(true);
  const [job, setJob] = useState(false);
  const [buildProduct, setBuildProduct] = useState(false);
  const { courses, setCoursesContext } = useCourses();
  const [selectedCourse, setSelectedCourse] = useState<any>({});
  const [promoInfo, setPromoInfo] = useState({
    promoActive: false,
    promoImage: "",
    timerActive: false,
    displayCohortStart: new Date(),
    displayCohortEnd: new Date(),
    IsSpecialPromo: false,
    SpecialCourse: "",
  });

  const setPromoDetails = async () => {
    const {
      promoActive,
      timerActive,
      promoImage,
      displayCohortStart,
      displayCohortEnd,
      IsSpecialPromo,
      SpecialCourse,
    } = await getDiscountPercentage();

    setPromoInfo({
      promoActive: promoActive,
      timerActive: timerActive,
      promoImage: promoImage,
      displayCohortStart: displayCohortStart,
      displayCohortEnd: displayCohortEnd,
      IsSpecialPromo: IsSpecialPromo,
      SpecialCourse: SpecialCourse,
    });
  };

  var typess: any = [
    "Tech Hero Today!",
    "Software Engineer",
    "Data Scientist",
    "Cyber Security Engineer",
    "Scrum Master",
    "Manual Tester",
    "",
  ];

  const innerWidthSize = window.innerWidth;
  useEffect(() => {
    (() => {
      setViewsize(innerWidthSize);
    })();
  }, [innerWidthSize, viewSize]);

  const handleShowAcquire = () => {
    setaquireSkill(true);
    setBuildProduct(false);
    setJob(false);
  };

  const handleShowBuild = () => {
    setaquireSkill(false);
    setBuildProduct(true);
    setJob(false);
  };

  const handleShowJob = () => {
    setaquireSkill(false);
    setBuildProduct(false);
    setJob(true);
  };

  const handleShowHand_On = () => {
    setaquireSkill(false);
    setBuildProduct(false);
    setJob(false);
  };

  const handleClose = () => {
    setPromoclose(true);
    setPromomodal(false);
  };

  const initModal = () => {
    return invokeModal(true);
  };

  const toScholarship = () => {
    navigate("/scholarship");
  };
  const navigateEngeneering = () => {
    navigate("/SchoolofEngineering");
  };
  const navigateDesign = () => {
    navigate("/SchoolofDesign");
  };
  const navigateData = () => {
    navigate("/SchoolofData");
  };
  const navigateCyber = () => {
    navigate("/SchoolofCyberSecurity");
  };
  const navigateMarketing = () => {
    navigate("/SchoolofMarketing");
  };
  const navigateProduct = () => {
    navigate("/SchoolofProduct");
  };
  const navigateNoCode = () => {
    navigate("/nocode");
  };

  const close = () => {
    return invokeModal(false);
  };
  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const toDoyenifyJobs = () => {
    window.open("https://jobs.doyenify.com", "_blank");
  };

  let navigate = useNavigate();
  const toBookConsulation = () => {
    navigate("/consult");
  };
  const toSignUp = () => {
    navigate("/signup");
  };

  const getStarted = () => {
    const element = document.getElementById("our-schools");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getajob = () => {
    navigate("/getajob");
  };

  const handsonexperience = () => {
    navigate("/handsonexperience");
  };
  const interviewprepcvreview = () => {
    window.open("https://aicvjobs.com/", "_blank");
  };
  const handleDetailsClose = () => {
    setShowDetails(false);
  };
  const giveCookieConsent = () => {
    setCookie("cookieConsent", true, { path: "/" });
  };

  const doyenAccess = () => {
    navigate("/doyenaccess");
  };
  const one_On_one = () => {
    navigate("/doyenaccess");
  };

  useEffect(() => {
    const getValues = async () => {
      if (!courses) {
        const Courses = await PopulateContext("Courses");
        if (Courses) {
          let filteredCourses = Courses.filter(
            (course: any) => !course.isArchive && course.isDeleted === false,
          );
          setCoursesContext(filteredCourses);
        }
      }
      if (courses) {
        let selectedCourse = courses.filter(
          (course: any) => course.CourseName === promoInfo.SpecialCourse,
        );
        setSelectedCourse(selectedCourse[0]);
      }
    };
    setPromoDetails();
    getValues();
    const listen = onAuthStateChanged(auth, (user: any) => {
      if (user) {
        setAuthUser(true);
      } else {
        setAuthUser(false);
      }
    });
    return () => {
      listen();
    };
  }, [courses, promoInfo.SpecialCourse, setCoursesContext]);

  return (
    <>
     <OneTapLogin />
      {promoInfo.promoActive && (
        <ChristmasBonanza
          getStarted={getStarted}
          promoActive={promoInfo.promoActive}
          promoImage={promoInfo.promoImage}
        />
      )}
      <Modal show={isShow}>
        <Modal.Header closeButton onClick={close}></Modal.Header>
        <Modal.Body>
          <div>
            <iframe
              width="100%"
              height="389px"
              title="youtubevideo"
              src="https://www.youtube.com/embed/Ik672PnY1Wo"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={showDetails} onHide={handleDetailsClose} centered={true}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div>
            <h4>Doyenify Limited uses cookies to:</h4>
            <ul className="list-disc">
              <li>
                Remember your preferences (language, font size, previous
                actions)
              </li>
              <li>
                Analyze site traffic and usage (helps us improve the site)
              </li>
              <li>Deliver personalized content and offers (optional)</li>
            </ul>
            <p>You can choose which cookies you allow:</p>
            <ul className="list-disc text-sm ">
              <div className="d-flex justify-content-between items-center">
                <li>
                  Essential Cookies: These cookies are strictly necessary for
                  the website to function.
                </li>

                <IOSSwitch sx={{ m: 1 }} defaultChecked disabled />
              </div>
              <div className="d-flex justify-content-between items-center">
                <li>
                  Performance Cookies: Allow us to analyze website traffic and
                  usage
                </li>

                <IOSSwitch sx={{ m: 1 }} />
              </div>
              <div className="d-flex justify-content-between items-center">
                <li>
                  Advertising Cookies: Used to deliver personalized content and
                  offers.
                </li>

                <IOSSwitch sx={{ m: 1 }} />
              </div>
            </ul>
            <p>
              Please note: Disabling advertising cookies won't remove ads
              entirely, but they will be less relevant to your interests.
            </p>
            <div className="col-md-2 d-flex justify-content-between">
              <button
                className="preference-btn"
                onClick={() => {
                  setCookie("cookieConsent", true, { path: "/" });
                  setShowDetails(false);
                }}
              >
                Accept
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {!cookies.cookieConsent && (
        <div
          style={{
            backgroundColor: "#ffffff",
            borderTop: "1px solid #D9D9D9",
            zIndex: "120",
            position: "fixed",
            bottom: "0",
            left: "0",
            right: "0",
          }}
        >
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <div style={{ padding: "20px" }}>
                <div className="row">
                  <div className="col-md-10">
                    <p style={{ fontSize: "17px" }}>
                      We use cookies to enhance your user experience. By using
                      our website, you agree to our use of cookies.
                    </p>
                  </div>
                  <div className="col-md-2 gap-3 d-flex justify-content-between">
                    <button
                      className="btn btn-success mr-2"
                      onClick={giveCookieConsent}
                    >
                      Accept
                    </button>
                    <button
                      className="preference-btn"
                      onClick={() => {
                        setShowDetails(true);
                      }}
                    >
                      Preferences
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      )}

      <div className="homemain">
        {promoInfo?.IsSpecialPromo &&
          (viewSize > 991 ? (
            <div className="fixed top-0 left-0 w-full z-50">
              <PromoDeskView
                close={promoclose}
                handleClose={handleClose}
                discountValue={selectedCourse?.discount}
                courseDetail={selectedCourse}
              />
            </div>
          ) : (
            <div className="fixed top-0 left-0 w-full z-50">
              <PromoMobileView
                close={promoModal}
                handleClose={handleClose}
                discountValue={selectedCourse?.discount}
                courseDetail={selectedCourse}
              />
            </div>
          ))}

        <div
          className={
            promoclose || viewSize < 991 || !promoInfo.IsSpecialPromo
              ? "mt-0"
              : "mt-20"
          }
        >
          <Header />
        </div>
        {/* <div className="headmid"></div> */}
        <div>
          <div>
            <div className="row">
              <div className="col-md-8">
                <div className="setCenter">
                  <div className="bannerpreventpdown -mt-[60px] adjust">
                    <h1 className="firstherotext ">
                      Become a{" "}
                      <div style={{ color: "#0f5a0d", display: "inline" }}>
                        <Typewriter
                          text={typess}
                          speed={210}
                          loop={true}
                          delay={210}
                        />
                      </div>
                    </h1>

                    <h5 className=" text-[33px] font-[500] mt-6">
                      {" "}
                      Get Certified with Hands-On Experience!
                    </h5>
                    <h5 className=" text-[29px]  font-[500] mt-4 text-[#367E3E]">
                      Earn a recognized certificate for every completed course
                    </h5>
                    <h6 className="text-[22px] font-[500] text-[#367E3E]">
                      Build a <strong>standout portfolio</strong>, and{" "}
                      <strong>gain practical experience</strong>
                    </h6>
                    <h6 className="text-[24px] font-[500] mt-8 mb-8  text-[#367E3E] ">
                      No Degree or Previous Tech Experience Needed!
                    </h6>
                  </div>

                  <div className="row ">
                    {authUser ? (
                      <>
                        <div className="col-md-4">
                          <button
                            className="contactusb"
                            onClick={toBookConsulation}
                          >
                            Contact Us
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <button className="contactusb" onClick={toSignUp}>
                            Join for Free
                          </button>
                        </div>
                      </>
                    )}
                    <div className="col-md-4">
                      <button
                        className="herobtn hover:text-white hover:border-none hover:bg-[#37be6d]"
                        onClick={getStarted}
                      >
                        Get Started
                      </button>
                    </div>
                  </div>
                  <div className="mt-8">
                    <p className="text-lg lg:text-2xl xl:text-2xl">
                      You can also explore available{" "}
                      <span
                        className="cursor-pointer text-[#047E35] underline"
                        onClick={toScholarship}
                      >
                        Scholarships
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="banimgpadsize">
                  <img
                    src="../../images/DoyenAcads.png"
                    style={{
                      width: "100%",
                      marginTop: "70px",
                      height: "400px",
                      marginBottom: "30px",
                    }}
                    alt=""
                  />
                  <div className="youtubeintrovideo">
                    <div className="ourIntroVideo" onClick={initModal}>
                      <FontAwesomeIcon
                        className="socialmed2"
                        icon={faYoutube}
                        style={{
                          marginLeft: "22px",
                          height: "34px",
                          display: "inline",
                          marginTop: "12px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {promoInfo.timerActive && (
          <CohortCountdown
            displayStartDate={promoInfo.displayCohortStart}
            displayEndDate={promoInfo.displayCohortEnd}
          />
        )}
        {!promoInfo.timerActive && (
          <div className="py-8" style={{ backgroundColor: "#F2FFD8" }}>
            <div className="text-center">
              <h4
                style={{
                  fontSize: "32px",
                  fontWeight: "500",
                  paddingTop: "17px",
                  paddingBottom: "17px",
                  color: "#0F4B16",
                }}
              >
                Our Students Have Achieved Remarkable Careers At
              </h4>
            </div>
            <div className="movementicon">
              <div className="achcompany">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <img
                        src="../../images/Microsoft.png"
                        className="companyi"
                        alt="microsoft"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Telsa.png"
                        className="companyi"
                        alt="telsa"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/roter.png"
                        className="companyi"
                        alt="roter"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Netflix.png"
                        className="companyi"
                        alt="netflix"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Wise.png"
                        className="companyi"
                        alt="wise"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Amazon.png"
                        className="companyi"
                        alt="amazon"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Apple.png"
                        className="companyi"
                        alt="apple"
                      />
                    </div>
                    <div className="col">
                      <img
                        src="../../images/Google.png"
                        className="companyi"
                        alt="google"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div id="" className="pt-8">
          <div
            className=" w-full text-center flex sm:flex-row justify-center items-center sm:gap-2 gap-6"
            style={{
              fontWeight: "600",
              paddingTop: "17px",
              paddingBottom: "32px",
              color: "#ffffff",
            }}
          >
            <button
              onClick={handleShowAcquire}
              className={`${aquireSkill && "bg-[#0F7D1A] text-[#ffffff]"} border-[#0F7D1A] border-[1px] ${!aquireSkill && "text-[#0F7D1A]"}  sm:rounded-lg rounded-[50px] sm:p-2 px-6 py-2`}
            >
              Acquire a skill
            </button>
            <button
              onClick={handleShowBuild}
              className={`  ${buildProduct && "bg-[#0F7D1A] text-[#ffffff]"} border-[#0F7D1A] border-[1px] ${!buildProduct && "text-[#0F7D1A]"} sm:rounded-lg rounded-[50px] sm:p-2 px-6 py-2`}
            >
              Build a product
            </button>
            <button
              onClick={handleShowHand_On}
              className={` ${!aquireSkill && !buildProduct && !job && "bg-[#0F7D1A] text-[#ffffff]"} border-[#0F7D1A] border-[1px] ${(aquireSkill || buildProduct || job) && "text-[#0F7D1A]"} sm:rounded-lg rounded-[50px]  sm:p-2 px-6 py-2`}
            >
              1-on-1 career coaching
            </button>
            <button
              onClick={handleShowJob}
              className={` ${job && "bg-[#0F7D1A] text-[#ffffff]"} border-[#0F7D1A] border-[1px] ${!job && "text-[#0F7D1A]"} sm:rounded-lg rounded-[50px] sm:p-2 px-6 py-2`}
            >
              Jobs
            </button>
          </div>

          <div className="flex justify-center">
            {buildProduct && (
              <div className="w-full mx-8 sm:grid-cols-1  md:mx-20 xl:mx-60 gap-4 grid grid-cols-2">
                <div className="border-[1px] rounded-[20px] border-[#367E3E]">
                  <div className=" m-4">
                    <img
                      src="/images/doyen_access/hands-on-xperience.jpeg"
                      alt=""
                      onClick={handsonexperience}
                      className="rounded-[20px] w-full h-[400px]"
                    />
                  </div>
                  <h1 className="mx-4  md:text-lg">Hands-on-Experience</h1>
                  <button
                    onClick={handsonexperience}
                    className="bg-[#367E3E] rounded-[10px] text-[#ffffff] mb-6 px-4 py-2 mx-4"
                  >
                    Learn more
                  </button>
                </div>

                <div className="border-[1px] border-[#367E3E]  rounded-[20px]">
                  <div className=" m-4">
                    <img
                      src="/images/doyen_access/DoyenLanding.jpeg"
                      alt=""
                      onClick={doyenAccess}
                      className="rounded-[20px] w-full h-[400px]"
                    />
                  </div>

                  <h1 className="mx-4 md:text-lg">Doyen Access</h1>
                  <button
                    onClick={doyenAccess}
                    className="bg-[#367E3E] rounded-[10px] text-[rgb(255,255,255)] mb-6 px-4 py-2 mx-4"
                  >
                    Learn more
                  </button>
                </div>
              </div>
            )}

            {aquireSkill && (
              <div className="text-center grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 mx-4 md:mx-20">
                <FlipCard
                  frontImg="../../images/software-eng.png"
                  backImg="../../images/eng-img.png"
                  title="Engineering"
                  handleClick={navigateEngeneering}
                />
                <FlipCard
                  frontImg="../../images/data-science.png"
                  backImg="../../images/science-img.png"
                  title="Data Science"
                  handleClick={navigateData}
                />
                <FlipCard
                  frontImg="../../images/product-design.png"
                  backImg="../../images/design-img.png"
                  title="Product Design"
                  handleClick={navigateDesign}
                />
                <FlipCard
                  frontImg="../../images/product-management.png"
                  backImg="../../images/management-img.png"
                  title="Product Management"
                  handleClick={navigateProduct}
                />
                <FlipCard
                  frontImg="../../images/cyber-security.png"
                  backImg="../../images/cyber-img.png"
                  title="Cyber Security"
                  handleClick={navigateCyber}
                />
                <FlipCard
                  frontImg="../../images/marketing.png"
                  backImg="../../images/marketing-img.png"
                  title="Marketing"
                  handleClick={navigateMarketing}
                />
                <FlipCard
                  frontImg="../../images/no-code.png"
                  backImg="../../images/no-code-img.png"
                  title="No-code"
                  handleClick={navigateNoCode}
                />
                <div className="flip-card w-full max-w-xs mx-auto h-80">
                  <div className="flip-card-inner">
                    <div className="flip-card-front">
                      <div className="relative w-full">
                        <img
                          src="../../images/video.png"
                          alt="videography"
                          className="rounded-lg shadow-md w-full h-80"
                        />

                        <div className="absolute top-0 right-0 px-4 py-4">
                          {weAreInDecember && (
                            <div className="border rounded-full bg-green-500 border-green-500 p-2 flex items-center justify-center shadow-md">
                              <img
                                alt="doyenify academy logo"
                                src="../../images/hat.png"
                                className="w-10 rounded-full object-contain"
                              />
                            </div>
                          )}
                        </div>

                        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                          <div className="text-center">
                            <h2 className="text-white px-10 text-base md:text-lg lg:text-3xl xl:text-3xl font-bold">
                              Videography
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flip-card-back bg-gray-800 rounded-lg flex items-center justify-center h-full">
                      <div className="text-center">
                        <img
                          src="../../images/video-img.png"
                          alt="videography"
                          className="w-44 mx-auto"
                        />
                        <h2 className="text-white text-base md:text-lg lg:text-2xl xl:text-2xl font-bold">
                          Videography
                        </h2>
                        <p className="mt-4 text-lg text-[#047E35] py-2 px-4 rounded">
                          Coming soon
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!aquireSkill && !buildProduct && !job && (
              <div className="grid grid-cols-1 w-full mx-8 xl:mx-60 md:mx-20">
                <div className="border-[1px] rounded-[20px] border-[#367E3E]">
                  <div className=" m-4 h-[400px]">
                    <img
                      src="/images/doyen_access/1-on-1.jpeg"
                      alt="img"
                      onClick={one_On_one}
                      className="rounded-[20px] object-cover  w-full h-full"
                    />
                  </div>
                  <h1 className="mx-4">1-on-1 career coaching</h1>
                  <button
                    onClick={one_On_one}
                    className="bg-[#367E3E] rounded-[10px] text-[#ffffff] mb-6 px-4 py-2 mx-4"
                  >
                    Learn more
                  </button>
                </div>
              </div>
            )}

            {job && (
              <div className="grid grid-cols-1 w-full mx-8 xl:mx-60 md:mx-20">
                <div className="border-[1px] rounded-[20px] border-[#367E3E]">
                  <div className=" m-4 h-[400px]">
                    <img
                      src="/images/doyen_access/JobPic.jpeg"
                      alt="img"
                      onClick={() =>
                        window.open("https://jobs.doyenify.com/", "_blank")
                      }
                      className="rounded-[20px] object-cover  w-full h-full"
                    />
                  </div>
                  <h1 className="mx-4">Jobs</h1>
                  <button
                    onClick={() =>
                      window.open("https://jobs.doyenify.com/", "_blank")
                    }
                    className="bg-[#367E3E] rounded-[10px] text-[#ffffff] mb-6 px-4 py-2 mx-4"
                  >
                    Learn more
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div id="howitwork" className="py-24">
          <h4
            className="text-center"
            style={{
              fontSize: "34px",
              fontWeight: "600",
              paddingTop: "17px",
              paddingBottom: "17px",
              color: "#0F4B16",
            }}
          >
            How It Works
          </h4>
          <div className="flex flex-col lg:flex-row xl:flex-row py-6 text-sm px-12">
            <div className="flex flex-col lg:flex-row xl:flex-row flex-wrap gap-2 w-full justify-between">
              <div
                className="text-center border border-white rounded-lg p-6 bg-white flex-1 min-w-[22%]"
                style={{ boxShadow: "0px 4px 8px 4px #367E3E1A" }}
              >
                <div
                  className="text-center howwork flex justify-center items-center"
                  onClick={getStarted}
                  style={{
                    backgroundColor: "#F2FFD8",
                    width: "80px",
                    height: "80px",
                    borderRadius: "100px",
                    cursor: "pointer",
                  }}
                >
                  <img src="../../images/getTrained.png" alt="training" />
                </div>
                <br />
                <h3 style={{ marginBottom: "14px" }}>Get Trained</h3>
                <p>
                  At Doyenify Academy, we offer cutting-edge training programs
                  designed to equip you with the knowledge and skills needed to
                  excel in the technology industry.
                </p>
                <div className="flex justify-center items-center mt-4">
                  <div
                    className="border-2 rounded-lg border-[#047E35] p-2 text-[#047E35] hover:bg-[#047E35] hover:text-white cursor-pointer"
                    onClick={getStarted}
                  >
                    Learn More
                  </div>
                </div>
              </div>

              <div
                className="text-center border border-white rounded-lg p-6 bg-white flex-1 min-w-[22%]"
                style={{ boxShadow: "0px 4px 8px 4px #367E3E1A" }}
              >
                <div
                  className="text-center howwork flex justify-center items-center"
                  onClick={handsonexperience}
                  style={{
                    backgroundColor: "#F2FFD8",
                    width: "80px",
                    height: "80px",
                    borderRadius: "100px",
                    cursor: "pointer",
                  }}
                >
                  <img src="../../images/handsOn.png" alt="training" />
                </div>
                <br />
                <h3 style={{ marginBottom: "14px" }}>
                  Get hands-on Experience
                </h3>
                <p>
                  Learning by doing is a core principle at Doyenify Academy.
                  Once you're enrolled, you'll dive into practical, hands-on
                  experiences that simulate real-world scenarios.
                </p>
                <div className="flex justify-center items-center mt-4">
                  <div
                    className="border-2 rounded-lg border-[#047E35] p-2 text-[#047E35] hover:bg-[#047E35] hover:text-white cursor-pointer"
                    onClick={handsonexperience}
                  >
                    Learn More
                  </div>
                </div>
              </div>

              <div
                className="text-center border border-white rounded-lg p-6 bg-white flex-1 min-w-[22%]"
                style={{ boxShadow: "0px 4px 8px 4px #367E3E1A" }}
              >
                <div
                  className="text-center howwork flex justify-center items-center"
                  onClick={interviewprepcvreview}
                  style={{
                    backgroundColor: "#F2FFD8",
                    width: "80px",
                    height: "80px",
                    borderRadius: "100px",
                    cursor: "pointer",
                  }}
                >
                  <img src="../../images/interview.png" alt="training" />
                </div>
                <br />
                <h3 style={{ marginBottom: "14px" }}>
                  Interview Prep/CV review
                </h3>
                <p>
                  We understand that landing your dream job involves more than
                  technical expertise. Our commitment to your success extends to
                  interview preparation and CV review.
                </p>
                <div className="flex justify-center items-center mt-4">
                  <div
                    className="border-2 rounded-lg border-[#047E35] p-2 text-[#047E35] hover:bg-[#047E35] hover:text-white cursor-pointer"
                    onClick={interviewprepcvreview}
                  >
                    Learn More
                  </div>
                </div>
              </div>

              <div
                className="text-center border border-white rounded-lg p-6 bg-white flex-1 min-w-[22%]"
                style={{ boxShadow: "0px 4px 8px 4px #367E3E1A" }}
              >
                <div
                  className="text-center howwork flex justify-center items-center"
                  onClick={getajob}
                  style={{
                    backgroundColor: "#F2FFD8",
                    width: "80px",
                    height: "80px",
                    borderRadius: "100px",
                    cursor: "pointer",
                  }}
                >
                  <img src="../../images/getJob.png" alt="training" />
                </div>
                <br />
                <h3 style={{ marginBottom: "14px" }}>Get the job</h3>
                <p>
                  Doyenify Academy has strong connections with industry-leading
                  companies and startups. As a graduate, you'll gain access to
                  our extensive network of employers actively seeking tech
                  talent.
                </p>
                <div className="flex justify-center items-center mt-4">
                  <div
                    className="border-2 rounded-lg border-[#047E35] p-2 text-[#047E35] hover:bg-[#047E35] hover:text-white cursor-pointer"
                    onClick={toDoyenifyJobs}
                  >
                    Learn More
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="font-bold text-[#075810] text-wrap flex flex-col pt-24"
                  style={{ fontSize: "20px", textAlign: "center" }}
                >
                  At Doyenify, we identify that cases may be different. Meet
                  with our industrial{" "}
                  <span>
                    expert for free consultation and proper mentorship.
                  </span>
                </div>
              </div>
            </div>
            <br />
            <button className="btn btn-success" onClick={toBookConsulation}>
              Book Free Consultation
            </button>
          </div>
        </div>

        <div className="py-8" style={{ backgroundColor: "#F2FFD8" }}>
          <h4
            className="text-center"
            style={{
              fontSize: "34px",
              fontWeight: "600",
              //paddingTop: "17px",
              padding: "17px 0",
              margin: 0,
              color: "#0F4B16",
            }}
          >
            What Our Students Say About Us
          </h4>
          <div className="container  px-0 py-4 ">
            <div className="flex flex-wrap justify-center tes items-center gap-4">
              {/* Testimonial 1 */}
              <div className="flex flex-row items-center w-[550px] gap-6 border-2 border-gray-200 rounded-xl p-6 bg-white shadow-md">
                <div className="flex flex-col items-center">
                  <img
                    className="rounded-full w-40 h-40 object-cover border-4 border-gray-300 shadow-xl"
                    src="../../images/davidson.jpg"
                    alt="Abimbola Davidson"
                  />
                  <p className="text-xl font-bold text-gray-800 mt-4 whitespace-nowrap">
                    Abimbola Davidson
                  </p>
                  <p className="text-gray-600 -mt-3 ">Software QA engineer</p>
                </div>
                <div>
                  <p className="text-gray-700 max-w-[300px]  text-justify">
                    As a graduate of Doyenify Academy's virtual learning
                    program, I found the experience to be exceptional. The
                    engaging instructors made complex concepts easy to
                    understand, and the hands-on projects, along with the
                    collaborative virtual environment, provided valuable
                    practical experience and global networking opportunities.
                  </p>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div className="flex  items-center gap-6 border- w-[550px] border-2 border-gray-200 rounded-xl p-6 bg-white shadow-md">
                <div className="flex flex-col float-left items-center">
                  <img
                    className="rounded-full w-40 h-40 object-cover border-4 border-gray-300 shadow-xl"
                    src="../../images/oluwatoyin.jpg"
                    alt="Ayankunle Oluwatoyin"
                  />
                  <p className="text-xl font-bold text-gray-800 mt-4 whitespace-nowrap">
                    Ayankunle Oluwatoyin
                  </p>
                  <p className="text-gray-600 -mt-3 ">Software Tester</p>
                </div>
                <div>
                  <p className="text-gray-700 max-w-[300px] text-justify">
                    As a graduate of Doyenify Academy’s Software Testing
                    program, I had an exceptional virtual learning experience.
                    With no prior IT background, I thrived due to the expert
                    instructors who fostered a supportive, engaging, and
                    collaborative environment.
                  </p>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div className="flex items-center gap-6 border-2 w-[550px] border-gray-200 rounded-xl p-6 bg-white shadow-md">
                <div className="flex flex-col float-left  items-center">
                  <img
                    className="rounded-full w-40 h-40 object-center border-4 border-gray-300 shadow-xl"
                    src="../../images/okoyecopy.png"
                    alt="Okoye Nonye"
                  />
                  <p className="text-xl font-bold text-gray-800 mt-4 whitespace-nowrap">
                    Okoye Nonye
                  </p>
                  <p className="text-gray-600 -mt-3">Digital Marketer</p>
                </div>

                <div>
                  <p className="text-gray-700 max-w-[300px] text-justify">
                    Earning my certification in Digital Marketing was a
                    transformative experience. I learned how to create
                    data-driven strategies, optimize content for engagement, and
                    analyze campaign performance. This training has prepared me
                    to drive impactful results for brands in today’s competitive
                    digital space.
                  </p>
                </div>
              </div>

              {/* Testimonial 4 */}
              <div className="flex items-center  gap-6 border-2 w-[550px] border-gray-200 rounded-xl p-6 bg-white shadow-md">
                <div className="flex flex-col  float-left items-center">
                  <img
                    className="rounded-full w-40 h-40 object-center border-4 border-gray-300 shadow-xl"
                    src="../../images/victor.png"
                    alt="Victor Akinola"
                  />
                  <p className="text-xl font-bold text-gray-800 mt-4 whitespace-nowrap">
                    Victor Akinola
                  </p>
                  <p className="text-gray-600 -mt-3">Software Tester</p>
                </div>
                <div>
                  <p className="text-gray-700 max-w-[300px] text-justify ">
                    I transformed from a QA novice to a skilled professional
                    through Doyenify Academy's hands-on training, world-class
                    tools, and expert coaching. This experience strengthened my
                    technical skills and commitment to improving technology’s
                    safety and reliability. I'm excited to use these skills to
                    positively impact the tech industry as a software tester.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default NewMain;
